import { render, staticRenderFns } from "./YearProductRank.vue?vue&type=template&id=761a14ac&scoped=true&"
import script from "./YearProductRank.vue?vue&type=script&lang=js&"
export * from "./YearProductRank.vue?vue&type=script&lang=js&"
import style0 from "./YearProductRank.vue?vue&type=style&index=0&id=761a14ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a14ac",
  null
  
)

export default component.exports